import { render } from "./NewRole.vue?vue&type=template&id=258f64ad&scoped=true"
import script from "./NewRole.vue?vue&type=script&lang=js"
export * from "./NewRole.vue?vue&type=script&lang=js"

import "./NewRole.vue?vue&type=style&index=0&id=258f64ad&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/admin-ui-svc/admin-ui-svc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-258f64ad"]])

export default __exports__